import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import { Url } from '../../config/config'
import { isLoggedIn } from '../../utils'
import useButtonLoader from '../../hooks/useButtonLoader'

export default function AddPartner() {
  const [iState, updateState] = useState({
    financeCompanyType: '',
    financeCompanyName: '',
    contactNum: '',
    email: '',
    contactPersonName: '',
    contactPersonContactNum: '',
    pinCode: '',
    address: '',
    state: '',
    city: '',
    list: [],
    stateList: [],
  })

  const {
    financeCompanyType,
    financeCompanyName,
    contactNum,
    email,
    contactPersonName,
    contactPersonContactNum,
    pinCode,
    address,
    state,
    city,
    list,
    stateList,
  } = iState
  const [errorField, setErrorField] = useState({
    financeCompanyType: '',
    financeCompanyName: '',
    contactNum: '',
    email: '',
    contactPersonName: '',
    contactPersonContactNum: '',
    pinCode: '',
    address: '',
    state: '',
    city: '',
  })

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    'Submit',
    'Please wait...',
  )

  const history = useNavigate()

  //************************Handel OnChange***************************** */
  const handleInputChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    updateState({
      ...iState,
      [name]: value,
    })
  }

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {}
    let formIsValid = true
    if (!financeCompanyType) {
      errorField['financeCompanyType'] = 'Please select Finance Company Type'
      formIsValid = false
    }

    if (!contactNum) {
      errorField['contactNum'] = 'Please enter contact number'
      formIsValid = false
    }

    if (!contactPersonName) {
      errorField['contactPersonName'] = 'Please enter contact person name'
      formIsValid = false
    }

    if (!state) {
      errorField['state'] = 'Please select state'
      formIsValid = false
    }

    if (!financeCompanyName) {
      errorField['financeCompanyName'] = 'Please enter finance company name'
      formIsValid = false
    }

    if (!email) {
      errorField['email'] = 'Please enter email address'
      formIsValid = false
    }

    if (!address) {
      errorField['address'] = 'Please enter address'
      formIsValid = false
    }
    if (!city) {
      errorField['city'] = 'Please enter city'
      formIsValid = false
    }

    setErrorField(errorField)
    return formIsValid
  }

  //*********************Update Password************************************ */
  const handelSubmit = async (event) => {
    try {
      // console.log(iState);
      event.preventDefault()
      if (handleValidation()) {
        setSubmitLoading(true)
        const res = await axios({
          url: `${Url}/financialPartnerMgmt`,
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          data: iState,
        })
        setSubmitLoading(false)
        console.log('res ', res.data)
        if (res.data.status == 200) {
          toast.success(res.data.message)
          history('/financial-partner')
        } else if (res.data.status === 419) {
          toast.error(res.data.message)
        } else {
          toast.error('Something went to wrong')
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  //**********************Financial Partner Type List************************************* */
  const financialPartnerType = async () => {
    try {
      const res = await axios({
        url: `${Url}/financialPartner`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      if (res.status === 200) {
        updateState({ ...iState, list: res.data.data.typeList })
      } else {
        toast.error('Something went to wrong')
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handelStateListing = async () => {
    try {
      const res = await axios({
        url: `${Url}/state`,
        method: 'GET',
      })
      updateState({
        ...iState,
        stateList: res.data.data.allState,
        list: res.data.data.financialTypeListing,
      })

      console.log('list ', res.data.data)
    } catch (err) {
      console.log(err)
      toast.error('Something went to wrong')
    }
  }
  useEffect(() => {
    //financialPartnerType()
    handelStateListing()
  }, [])
  return (
    <React.Fragment>
      <title>Add New Financial Partner</title>
      <div className="WrapperArea _add_partner">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title">Add New Financial Partner</h4>
            <form method="POST">
              <div className="PasswordArea">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Finance Company Type</label>
                      <select
                        className="form-control"
                        name="financeCompanyType"
                        value={financeCompanyType}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Finance Company Type</option>
                        {list &&
                          list.length > 0 &&
                          list.map((item, i) => (
                            <option key={i} value={item._id}>
                              {item.financeCompanyType}
                            </option>
                          ))}
                      </select>
                      <span style={{ color: 'red' }} className="error">
                        {errorField.financeCompanyType}
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input
                        type="text"
                        value={contactNum}
                        onChange={handleInputChange}
                        name="contactNum"
                        className="form-control"
                        placeholder="Phone Number"
                        maxLength="10"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault()
                          }
                        }}
                      />
                      <span style={{ color: 'red' }} className="error">
                        {errorField.contactNum}
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Contact Person Name</label>
                      <input
                        type="text"
                        value={contactPersonName}
                        onChange={handleInputChange}
                        name="contactPersonName"
                        className="form-control"
                        placeholder="Contact Person Name"
                      />
                      <span style={{ color: 'red' }} className="error">
                        {errorField.contactPersonName}
                      </span>
                    </div>

                    {/* <div className="form-group">
                      <label>Pin Code</label>
                      <input
                        type="text"
                        value={pinCode}
                        onChange={handleInputChange}
                        name="pinCode"
                        className="form-control"
                        placeholder="Pin Code"
                        maxLength="6"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.pinCode}
                      </span>
                    </div> */}

                    <div className="form-group">
                      <label>State</label>
                      {/* <input
                        type="text"
                        value={state}
                        onChange={handleInputChange}
                        name="state"
                        className="form-control"
                        placeholder="State"
                      /> */}
                      <select
                        className="form-control"
                        name="state"
                        onChange={handleInputChange}
                      >
                        <option>Select Your State</option>
                        {stateList &&
                          stateList.length > 0 &&
                          stateList.map((state, i) => (
                            <option key={i} value={state.state}>
                              {state.state}
                            </option>
                          ))}
                      </select>
                      <span style={{ color: 'red' }} className="error">
                        {errorField.state}
                      </span>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Finance Company Name</label>
                      <input
                        type="text"
                        value={financeCompanyName}
                        onChange={handleInputChange}
                        name="financeCompanyName"
                        className="form-control"
                        placeholder="Finance Company Name"
                      />
                      <span style={{ color: 'red' }} className="error">
                        {errorField.financeCompanyName}
                      </span>
                    </div>

                    {/* <div className="form-group">
                      <label>Contact Person Phone No.</label>
                      <input
                        type="text"
                        value={contactPersonContactNum}
                        onChange={handleInputChange}
                        name="contactPersonContactNum"
                        className="form-control"
                        placeholder="Contact Person Phone No"
                        maxLength="10"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <span style={{ color: "red" }} className="error">
                        {errorField.contactPersonContactNum}
                      </span>
                    </div> */}

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        value={email}
                        onChange={handleInputChange}
                        name="email"
                        className="form-control"
                        placeholder="Email"
                      />
                      <span style={{ color: 'red' }} className="error">
                        {errorField.email}
                      </span>
                    </div>

                    <div className="form-group">
                      <label>City.</label>
                      <input
                        type="text"
                        value={city}
                        onChange={handleInputChange}
                        name="city"
                        className="form-control"
                        placeholder="City"
                      />
                      <span style={{ color: 'red' }} className="error">
                        {errorField.city}
                      </span>
                    </div>

                    <div className="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        value={address}
                        onChange={handleInputChange}
                        name="address"
                        className="form-control"
                        placeholder="Address"
                      />
                      <span style={{ color: 'red' }} className="error">
                        {errorField.address}
                      </span>
                    </div>
                  
                  </div>
                  <div className='button_wrap'>
                    <button
                      className="button"
                      onClick={handelSubmit}
                      ref={submitButtonElement}
                    >
                      Submit
                    </button>

                    </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
